export default class WorkPreparationOptions {
  constructor(
    readonly includePassed: boolean,
    readonly myDossiers: boolean,
    readonly isCreationDate: boolean,
  ) {}
}